export default __webpack_public_path__ + "static/media/25.7e881ee1.jpg";